/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { Type } from '@sinclair/typebox';

var SubscriptionSchema = Type.Object({
  type: Type.String(),
  url: Type.String({
    format: 'uri',
    pattern: '^https://'
  }),
  events: Type.Array(Type.String())
});
var CallbackResultSchema = Type.Object({
  transformers: Type.Array(Type.Any()),
  action: Type.Optional(Type.String()),
  deliverEvent: Type.Optional(Type.String()),
  persistenceStates: Type.Optional(Type.Array(Type.String()))
});
var ChildCallbackResultSchema = Type.Object({
  definitionId: Type.String(),
  transformers: Type.Array(Type.Any()),
  action: Type.Optional(Type.String()),
  deliverEvent: Type.Optional(Type.String())
});
var MainRepresentativeSchema = Type.Object({
  fullName: Type.String(),
  email: Type.String()
});
var AvailableDocumentSchema = Type.Object({
  category: Type.String(),
  type: Type.String()
});
var language = Type.Optional(Type.String());
var initialEvent = Type.Optional(Type.String());
var subscriptions = Type.Optional(Type.Array(SubscriptionSchema));
var uiOptions = Type.Optional(Type.Object({
  redirectUrls: Type.Optional(Type.Object({
    success: Type.String({
      format: 'uri'
    }),
    failure: Type.String({
      format: 'uri'
    })
  }))
}));
var WorkflowRuntimeConfigSchema = Type.Object({
  language: language,
  initialEvent: initialEvent,
  subscriptions: subscriptions,
  uiOptions: uiOptions
});
Type.Object({
  language: language,
  initialEvent: initialEvent,
  subscriptions: subscriptions,
  isAssociatedCompanyKybEnabled: Type.Optional(Type.Boolean()),
  isCaseOverviewEnabled: Type.Optional(Type.Boolean()),
  isDocumentTrackerEnabled: Type.Optional(Type.Boolean()),
  isCaseRiskOverviewEnabled: Type.Optional(Type.Boolean()),
  isLegacyReject: Type.Optional(Type.Boolean()),
  isLockedDocumentCategoryAndType: Type.Optional(Type.Boolean()),
  isManualCreation: Type.Optional(Type.Boolean()),
  isDemo: Type.Optional(Type.Boolean()),
  isExample: Type.Optional(Type.Boolean()),
  supportedLanguages: Type.Optional(Type.Array(Type.String())),
  completedWhenTasksResolved: Type.Optional(Type.Boolean()),
  workflowLevelResolution: Type.Optional(Type.Boolean()),
  allowMultipleActiveWorkflows: Type.Optional(Type.Boolean()),
  availableDocuments: Type.Optional(Type.Array(AvailableDocumentSchema)),
  callbackResult: Type.Optional(CallbackResultSchema),
  childCallbackResults: Type.Optional(Type.Array(ChildCallbackResultSchema)),
  createCollectionFlowToken: Type.Optional(Type.Boolean()),
  mainRepresentative: Type.Optional(MainRepresentativeSchema),
  customerName: Type.Optional(Type.String()),
  enableManualCreation: Type.Optional(Type.Boolean()),
  kybOnExitAction: Type.Optional(Type.Union([Type.Literal('send-event'), Type.Literal('redirect-to-customer-portal')])),
  reportConfig: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
  hasUboOngoingMonitoring: Type.Optional(Type.Boolean()),
  maxBusinessReports: Type.Optional(Type.Number()),
  isMerchantMonitoringEnabled: Type.Optional(Type.Boolean()),
  isOngoingMonitoringEnabled: Type.Optional(Type.Boolean()),
  isCollectionFlowPageRevisionEnabled: Type.Optional(Type.Boolean()),
  disableVideoGuide: Type.Optional(Type.Boolean()),
  disableAiSummary: Type.Optional(Type.Boolean())
});

export { WorkflowRuntimeConfigSchema };
//# sourceMappingURL=config-schema.js.map
